module.exports = __webpack_public_path__ + "img/xl.58d7c90f.png";